__turbopack_context__.v({
  "root": "DesktopRecoveryComponent-module__0wJt7G__root",
});
